function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * @license Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module typing/input
 */
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import InputCommand from './inputcommand';
import injectUnsafeKeystrokesHandling from './utils/injectunsafekeystrokeshandling';
import injectTypingMutationsHandling from './utils/injecttypingmutationshandling';
/**
 * Handles text input coming from the keyboard or other input methods.
 *
 * @extends module:core/plugin~Plugin
 */

var Input =
/*#__PURE__*/
function (_Plugin) {
  _inherits(Input, _Plugin);

  function Input() {
    _classCallCheck(this, Input);

    return _possibleConstructorReturn(this, _getPrototypeOf(Input).apply(this, arguments));
  }

  _createClass(Input, [{
    key: "init",

    /**
     * @inheritDoc
     */
    value: function init() {
      var editor = this.editor; // TODO The above default configuration value should be defined using editor.config.define() once it's fixed.

      var inputCommand = new InputCommand(editor, editor.config.get('typing.undoStep') || 20);
      editor.commands.add('input', inputCommand);
      injectUnsafeKeystrokesHandling(editor);
      injectTypingMutationsHandling(editor);
    }
    /**
     * Checks batch if it is a result of user input - e.g. typing.
     *
     *		const input = editor.plugins.get( 'Input' );
     *
     *		editor.model.document.on( 'change:data', ( evt, batch ) => {
     *			if ( input.isTyping( batch ) ) {
     *				console.log( 'The user typed something...' );
     *			}
     *		} );
     *
     * **Note:** This method checks if the batch was created using {@link module:typing/inputcommand~InputCommand 'input'}
     * command as typing changes coming from user input are inserted to the document using that command.
     *
     * @param {module:engine/model/batch~Batch} batch A batch to check.
     * @returns {Boolean}
     */

  }, {
    key: "isInput",
    value: function isInput(batch) {
      var inputCommand = this.editor.commands.get('input');
      return inputCommand._batches.has(batch);
    }
  }], [{
    key: "pluginName",

    /**
     * @inheritDoc
     */
    get: function get() {
      return 'Input';
    }
  }]);

  return Input;
}(Plugin);

export { Input as default };